import { render } from "./HomeCierre.vue?vue&type=template&id=e4876ee0"
import script from "./HomeCierre.vue?vue&type=script&lang=js"
export * from "./HomeCierre.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__